export const getRandom = <T>(items: T[], limit: number): T[] => {
  if (limit <= 0) return [];
  if (limit >= items.length) return items;

  const selected = new Set<number>();
  const result: T[] = [];

  while (result.length < limit) {
    const index = Math.floor(Math.random() * items.length);
    if (!selected.has(index)) {
      selected.add(index);
      result.push(items[index]);
    }
  }

  return result;
};
